import fetch from '../utils/fetch';
import { getURL, solutionsUrl, experienceRegistryUrl, companiesURL } from 'endpoints';
const SDK = require( '@nackle/company-sdk' );

function CompanySDK() {
    const sdk = SDK( companiesURL, fetch );

    async function getCompanies() {
        const result = await sdk.getCompanies();
        return result.companyList;
    }

    const experienceNames = {
        ARCADE: 'Arcade',
        CONTESTS: 'Contests',
        GIFT_CODE: 'Gift Code',
        KADHAVU: 'Kadhavu',
        MARKETPLACE: 'Marketplace Redirect',
        PROFILE: 'Profile',
        SERVICE_AWARDS: 'DayMaker Service Awards',
        SERVICE_AWARDS_CELEBRATION: 'DMSA Celebration Page',
        TOWER: 'Home'
    };

    async function getExperiences( companyId ) {
        const res = await fetch( `${ experienceRegistryUrl }/services/v1/experience` );

        if ( !res.ok ) {
            const text = await res.text();
            throw new Error( `Non successful response from experience: ${ text }` );
        }

        const { experiences } = await res.json();

        return experiences;
    }
    async function getSolutions( companyId ) {
        const res = await fetch( `${ solutionsUrl }/solutions` );

        if ( !res.ok ) {
            const text = await res.text();
            throw new Error( `Non successful response from solutions: ${ text }` );
        }

        const { solutions } = await res.json();

        return solutions;
    }
    async function getWebapps( companyId ) {
        // get solutions and experiences
        const [ solutions, experiences ] = await Promise.all( [
            getSolutions( companyId ),
            getExperiences( companyId )
        ] );

         // map the experiences so we can look them up
         const experiencesMap = {};
         experiences.forEach( experience => {
             experiencesMap[ experience.id ] = experience;
         } );
         // get all the urls by going through each solution and each experiences
         const webapps = [];
         const webappMap = {};
         solutions.forEach( solution => {
            // get all the possible domains for a solution
            const possibleDomains = new Set();
            possibleDomains.add( 'biw.cloud' );
            possibleDomains.add( 'recognition-now.io' );
            if ( Array.isArray( solution.customDomains ) ) {
                solution.customDomains.forEach( customDomain => {
                    possibleDomains.add( customDomain.domain );
                } );
            }
            solution.experiences.forEach( experienceId => {
                const experience = experiencesMap[ experienceId ];
                if ( experience ) {
                    possibleDomains.forEach( experienceDomainAndPath => {
                        // TODO: Someday the structure will be like `${ experienceDomainAndPath }/${ experience.identity }` and the following code can be removed.
                        // experienceDomainAndPath = `${ experienceDomainAndPath }/${ experience.identity }`;

                        // add experience identity or correct the domain for legacy web sites
                        if ( experienceNames.GIFT_CODE.includes( experience.name ) ) {
                            experienceDomainAndPath = '(env.)myawardcode.com';
                        } else if ( experienceNames.SERVICE_AWARDS.includes( experience.name ) ) {
                            experienceDomainAndPath = '(env.)myawardsite.com';
                        } else if ( experienceNames.SERVICE_AWARDS_CELEBRATION.includes( experience.name ) ) {
                            experienceDomainAndPath = '(env.)myawardsite.com';
                        } else {
                            // some identity include a domain; those need to be striped out until they are cleaned up.
                            let normalizedExperienceIdentity = experience.identity.toLowerCase().replace( '.biw.cloud', '' );
                            // currently the exprience identity is between the environment and domain,
                            // so if the experience domain includes the environment, that needs to be removed
                            const environmentPrefix = getURL( '(env.)' );
                            if ( experienceDomainAndPath.startsWith( environmentPrefix ) ) {
                                experienceDomainAndPath = experienceDomainAndPath.substring( environmentPrefix.length );
                            }
                            experienceDomainAndPath = `(env.)${ normalizedExperienceIdentity }.${ experienceDomainAndPath }`;
                        }

                        const webapp = {
                            solutionId: solution.id,
                            solutionName: solution.name,
                            solutionIdentity: solution.identity,
                            experienceId: experience.id,
                            experienceName: experience.name,
                            experienceIdentity: experience.identity,
                            isPrimary: experience.id === solution.primaryExperience,
                            url: getURL( `https://${ solution.identity }.${ experienceDomainAndPath }` )
                        };

                        if ( !webappMap[ webapp.url ] ) {
                            webappMap[ webapp.url ] = webapp;
                            webapps.push( webapp );
                        }
                    } );
                }
             } );
         } );

        return webapps;
    }

    async function getCompany( companyId ) {
        const company = await sdk.getCompany( companyId, true );
        if ( !company ) {
            return null;
        }
        // set a countries array, with the country list + campaing info
        company.countries = company.countryList.map( country => {
            if ( !Array.isArray( country.campaigns ) ) {
                return country;
            }
            return {
                ...country,
                ...( country.campaigns[ 0 ] || {} )
            };
        } );

        // add webapp urls as identifiers
        if ( !company.identifierList ) {
            company.identifierList = [];
        }
        try {
            const webapps = await getWebapps( company.id );
            webapps.forEach( webapp => {
                const parts = webapp.url.split( '//' );
                if ( parts[ 1 ] ) {
                    parts[ 1 ] = parts[ 1 ].split( '/' )[ 0 ];
                }
                webapp.url = parts.join( '//' );

                company.identifierList.push( webapp.url );
            } );
        } catch ( error ) {
            console.error( error );
        }

        return company;
    }

    return {
        getCompanies,
        getCompany
    };
}

export default new CompanySDK();
